
import { Shield, Award, Database, Users, CheckCircle, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";

interface TrustBadgeDisplayProps {
  variant?: "header" | "hero" | "footer";
  className?: string;
}

const TrustBadgeDisplay = ({ variant = "hero", className = "" }: TrustBadgeDisplayProps) => {
  const badges = [
    {
      icon: Database,
      label: "Evidence-Based",
      description: "Peer-reviewed research",
      color: "bg-gray-100 text-gray-800 border-gray-200"
    },
    {
      icon: Award,
      label: "Clinically Validated",
      description: "Medical protocols",
      color: "bg-blue-100 text-blue-800 border-blue-200"
    },
    {
      icon: Users,
      label: "Professional Grade",
      description: "Healthcare standard",
      color: "bg-green-100 text-green-800 border-green-200"
    },
    {
      icon: Shield,
      label: "Secure Analysis",
      description: "Protected data",
      color: "bg-purple-100 text-purple-800 border-purple-200"
    }
  ];

  if (variant === "header") {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <Database className="h-4 w-4 text-gray-600" />
        <span className="text-sm font-medium text-gray-600">Evidence-Based</span>
        <span className="text-xs text-gray-400">•</span>
        <span className="text-sm font-medium text-blue-600">Clinical Grade</span>
      </div>
    );
  }

  if (variant === "footer") {
    return (
      <div className={`grid grid-cols-2 md:grid-cols-4 gap-2 ${className}`}>
        {badges.map((badge, index) => (
          <div key={index} className="flex items-center space-x-1 text-xs text-gray-600">
            <badge.icon className="h-3 w-3" />
            <span>{badge.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 gap-4 ${className}`}>
      {badges.map((badge, index) => (
        <Card key={index} className="p-4 bg-white border hover:shadow-sm transition-all duration-200">
          <div className="flex flex-col items-center text-center space-y-2">
            <div className={`p-2 rounded-lg ${badge.color.replace('text-', 'bg-').replace('border-', '').replace('bg-', 'bg-opacity-20 bg-')}`}>
              <badge.icon className="h-5 w-5 text-current" />
            </div>
            <div>
              <Badge variant="outline" className={badge.color}>
                {badge.label}
              </Badge>
              <p className="text-xs text-gray-500 mt-1">{badge.description}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default TrustBadgeDisplay;
